const PageTypeMap = require('../../../../../../app_bata_sfra/cartridge/client/default/js/analytics/analytics-mapping');
var events = require('../../../../../../app_bata_sfra/cartridge/client/default/js/analytics/analytics-events');
var pageMetaDataUtils = require('../../../../../../app_bata_sfra/cartridge/client/default/js/pageMetaDataUtils');

//global variable used for orders
var productOrder;

var scrollPosition = {
    "25": false,
    "50": false,
    "75": false,
    "100": false
};

/**
 * Returns the sales status of a product based on discount data.
 * @param {Object} product - jQuery or plain object representing the product.
 * @returns {string} - "on sale" if discounted, otherwise "full price".
 */
function getSalesStatus(product) {
    var isSalesStatus = product instanceof jQuery ? product.data('discount') : product.discount;
    return isSalesStatus ? "on sale" : "full price";
}

/**
 * Extend analytics product with categories related to Google Analytics 4
 * @param {Object} product Analytics product
 * @param {Object} productData Product data
 * @param {Object} attributeName Analytics product's attribute name (postfix number will be added)
 * @returns Extended analytics product
 */
function extendProductDataWithGA4Categories(product, productData, attributeName) {
    if (!product || !productData) {
        return;
    }
    attributeName = attributeName || 'category';
    let index;
    let key;
    for (index = 1; index <= 5; index++) {
        if (productData) {
            if (!productData['category' + index]) {
                continue;
            }
        }
        key = attributeName + index;
        // GA4 first category attribute does not contain postfix number
        if (attributeName === 'item_category' && index === 1) {
            key = attributeName;
        }
        if (productData) {
            product[key] = productData['category' + index];
        }
    }
    return product;
}

/**
 * GA4 Get item_list_id by product data
 * @param {Object} product Product object
 * @returns {String} GA4 list id
 */
function ga4GetProductItemListId(product) {
    if (!product) {
        return;
    }
    if (product.listId) {
        return product.listId;
    }
    // check saved list id after click on product tile
    if (window.bata_com_ns.analytics.pageType === "product" && document.referrer) {
        try {
            let listId = window.sessionStorage.getItem("analyticsListId");
            if (listId) {
                window.sessionStorage.removeItem("analyticsListId");
                $('.analytics-productPDP.analytics-product').data('listId', listId);
                return listId;
            }
        } catch (error) {
            // sessionStorage not supported
        }
    }

    // set current category id and path for PLP
    if (window.bata_com_ns.analytics.pageType === "category" || window.bata_com_ns.analytics.pageType === "brands") {
        var categoryId = $("div.grid-footer > input.category-id").val() || $('.js-analytics-search-category').data('analytics-category-id');
        if (categoryId) {
            return categoryId;
        } else {
            return "product search result";
        }
    }
    if (window.bata_com_ns.analytics.pageType === "product") {
        return "detail";
    }
    return product.list || window.bata_com_ns.analytics.pageType;
}

/**
 * GA4 formatted product items
 * @param {Array} products Analytics products
 * @returns GA4 formatted product items list
 */
function ga4GetProducts(products) {
    if (!products || !products.length) {
        return [];
    }
    var mappedProducts = [];
    mappedProducts = products.map(function(product) {
        let isSalesStatus = getSalesStatus(product);
        let ga4Product = {
            item_id: product.id,
            item_name: product.name,
            index: product.position || 0,
            item_brand: product.brand,
            price: parseFloat(product.price),
            quantity: product.quantity || 1,
            item_dimension1: product.dimension1 || "",
            item_dimension2: product.dimension2 || "",
            item_dimension3: product.dimension3 || "",
            item_sales_status: isSalesStatus
        };

        extendProductDataWithGA4Categories(ga4Product, product, 'item_category');
        if (product.size) {
            ga4Product.item_size = product.size;
        }
        if (product.variant) {
            ga4Product.item_variant = product.variant;
        }
        if (product.coupon) {
            ga4Product.coupon = product.coupon;
        }
        if (product.discount) {
            ga4Product.discount = parseFloat(product.discount);
        }
        if (product.promotionName) {
            ga4Product.promotion_id = product.promotionName;
            ga4Product.promotion_name = product.promotionName;
        }
        ga4Product.item_list_id = ga4GetProductItemListId(product);
        ga4Product.item_list_name = ga4Product.item_list_id;
        if (product.genderName) {
            ga4Product.item_gender = product.genderName;
        }
        if (product.itemSeason) {
            ga4Product.item_season = product.itemSeason;
        }
        if (product.stockStatus) {
            ga4Product.item_stock_status = product.stockStatus;
        }
        if (product.list_name) {
            ga4Product.item_list_name = product.list_name;
        }
        return ga4Product;
    });
    return mappedProducts;
}

/**
 * GA4 Get value of products
 * @param {Arrray} products products to be evaluated
 * @returns value of all products in array
 */
function ga4GetProductsValue(products) {
    let value = products.reduce((accumulator, product) => {
        return accumulator + parseFloat(product.price) * product.quantity;
    }, 0);
    return parseFloat(value);
}

/**
 * GA4 Get cart page data
 */
function ga4GetCartData() {
    var $cartInfo = $('#analytics-cartInfo');
    return {
        couponNames: $cartInfo.data('coupons-name'),
        value: $cartInfo.data('value')
    };
}

/**
 * GA4 formatted promotion items
 * @param {Array} products Analytics promotions
 * @returns GA4 formatted promotion items list
 */
function ga4GetPromotions(promotions) {
    if (!promotions || !promotions.length) {
        return [];
    }
    var mappedPromotions = [];
    mappedPromotions = promotions.map(function(promotion) {
        return {
            item_id: promotion.id,
            promotion_id: promotion.id,
            promotion_name: promotion.name,
            creative_name: promotion.creative,
            creative_slot: promotion.position
        };
    });
    return mappedPromotions;
}

/**
 * @description extract the user email and phone from menuAccount - analytics-user, populated after login
 * @return user {obj} an object with the customer email and phone
 */
function getCustomerEmailAndPhone() {
    let $user = $('#analytics-user');
    let customerEmail = $user.data('email') || '';
    let customerPhone = $user.data('phone') || '';

    return {
        customerEmail,
        customerPhone
    };
}

/**
 * @description get the product tile information
 * @param $product {div} the analytics-product div where the data will be extracted
 * @return product {Object} a the product Object contains the analytics informations
 */
function getProductBaseData($product) {
    var product = {
        'name': $product.data('name'),
        'id': $product.data('id'),
        'price': $product.data('price'),
        'brand': $product.data('brand'),
        'category': $product.data('category'),
        'discount': $product.data('discount'),
        'promotionName': $product.data('promotionName')
    };
    let size = $product.data('size');
    if (size) {
        product.size = size;
    }
    let listId = $product.data('listId');
    if (listId) {
        product.listId = listId;
    }
    let genderName = $product.data('gender-name');
    if (genderName) {
        product.genderName = genderName;
    }
    let itemSeason = $product.data('item-season');
    if (itemSeason) {
        product.itemSeason = itemSeason;
    }
    let stockStatus = $product.data('stock-status');
    if (stockStatus) {
        product.stockStatus = stockStatus;
    }
    return product;
}

/**
 * @description get the product tile information
 * @param $product {div} the analytics-tileproduct div where the data will be extracted
 * @return product {Object} a the product Object contains the analytics tiles informations
 */
function getProductTileData($product) {
    var color = $product.data('color'),
        size = $product.data('size');
    var variant = size ? color + ' | ' + size : color;
    var product = getProductBaseData($product);
    product.variant = variant;

    // quantity
    var quantity = $product.data('quantity');
    if (typeof quantity !== 'undefined' && quantity !== null && !isNaN(quantity)) {
        product.quantity = parseInt(quantity);
    }

    // custom attributes - dimensions
    var dimension1 = $product.data('dimension1');
    if (dimension1) {
        product.dimension1 = dimension1;
    }
    var dimension2 = $product.data('dimension2');
    if (dimension2) {
        product.dimension2 = dimension2;
    }
    var dimension3 = $product.data('dimension3');
    if (dimension3) {
        product.dimension3 = dimension3;
    }

    // ga4 categories
    extendProductDataWithGA4Categories(product, $product.data());

    return product;
}

/**
 * @description get the product tile information with also the three dimensions and the tryon
 * @param $product {div} the analytics-tileproduct div where the data will be extracted
 * @return product {Object} a the product Object contains the analytics informations
 */
function getProductTileDataExtended($product) {
    var product = getProductTileData($product);
    product.dimension1 = $product.data('dimension1');
    product.dimension2 = $product.data('dimension2');
    product.dimension3 = $product.data('dimension3');
    //IN-AR TRY ON
    if ($product.data('opened-in-ar-tryon')) {
        product.openedInArTryon = $product.data('opened-in-ar-tryon');
    }

    return product;
}

/**
 * @description extract all the products impressions from the dom
 * @param index {number} the index to start the position of the products
 * @return products {list} a list of all the products showed in page
 */
function getProductsData(index) {
    var products = [],
        product,
        $product;
    var position = index || 0;
    //track the plp products
    var $productsPLP = $('.analytics-ProductList .analytics-product.unregistered');
    if ($productsPLP.length > 1) {
        $productsPLP.each(function() {
            $product = $(this);
            product = getProductTileData($product);
            $product.data('position', position);
            product.position = position;
            product.list = window.bata_com_ns.analytics.pageType;
            position++;
            products.push(product);

            $product.removeClass('unregistered');
        });
    } else {
        product = getProductTileData($productsPLP);
        if (!product.id) {
            return;
        }
        $productsPLP.data('position', position);
        product.position = position;
        product.list = window.bata_com_ns.analytics.pageType;
        position++;
        products.push(product);

        $productsPLP.removeClass('unregistered');
    }
    window.bata_com_ns.analytics.productsDisplayed = position;
    return products;
}

/**
 * @description extract all the products impressions from the search dom
 * @param index {number} the index to start the position of the products
 * @return products {list} a list of all the products showed in page
 */
function getProductsDataSearch(index) {
    var products = [],
        product,
        $product;
    var position = index;
    var list = window.bata_com_ns.analytics.pageType + ' search suggestion';
    //get the search products's data from the DOM
    var $productsSearch = $('.analytics-ProductList .analytics-product-search.unregistered');
    if ($productsSearch.length > 1) {
        $productsSearch.each(function() {
            $product = $(this);
            product = getProductTileData($product);
            $product.data('position', position);
            product.position = position;
            product.list = list;
            product.item_list_id = list;
            position++;
            products.push(product);

            $product.removeClass('unregistered');
        });
    } else {
        product = getProductTileData($productsSearch);
        $productsSearch.data('position', position);
        product.position = position;
        product.list = list;
        product.item_list_id = list;
        position++;
        products.push(product);

        $productsSearch.removeClass('unregistered');
    }
    return products;
}

/**
 * @description extract all the products impressions from the cart in dom (cart or minicart)
 * @param pageType {String} the location where the event is triggered
 * @return products {list} a list of all the products showed in cart
 */
function getProductsCartData(pageType, expressPayment) {
    var products = [],
        product,
        $product;

    let selector = `.analytics-cart > .analytics-product${expressPayment ? '' : '.unregistered'}`;

    var $productsElements = $(selector);
    if ($productsElements.length > 1) {
        $productsElements.each(function() {
            $product = $(this);
            product = getProductTileData($product);
            product.position = $product.data('position');
            product.list = pageType;
            product.listId = $product.data('listId');
            products.push(product);
            $product.removeClass('unregistered');
        });
    } else if ($productsElements.length === 1) {
        product = getProductTileData($productsElements);
        product.position = $productsElements.data('position');
        product.list = pageType;
        product.listId = $productsElements.data('listId');
        products.push(product);
        $productsElements.removeClass('unregistered');
    }
    return products;
}

/**
 * @description extract all the products data from checkout page
 * @param step {Int} the checkout's step
 * @param isCartOpened {boolean} optional: set on true only for checkout's step where the products's data needs to be picked from cart or minicart
 * @return products {list} a list of all the products showed in checkout page
 */
function getCheckoutProducts(step, isCartOpened) {
    var products = [],
        product,
        $product,
        $checkoutProducts;
    //if the minicart was opened means that some products could have been deleted (available only in the first and second checkout step)
    if (step < 2 && isCartOpened) {
        //if the user is in cart page picks the product's data directly from the main cart (and not from the minicart)
        if (window.bata_com_ns.analytics.pageType === 'cart') {
            $checkoutProducts = $('.js-analytics-MainCart .analytics-cart > .analytics-product');
        } else {
            $checkoutProducts = $('.analytics-cart > .analytics-product');
        }
    } else {
        $checkoutProducts = $('.js-analytics-checkout > .analytics-product');
    }
    var elementsFound = $checkoutProducts.length;
    if (elementsFound === 0) {
        products = productOrder;
    } else if (elementsFound > 1) {
        $checkoutProducts.each(function() {
            $product = $(this);
            product = getProductTileDataExtended($product);
            product.quantity = parseInt($product.data('quantity'));
            products.push(product);
        });
    } else {
        product = getProductTileDataExtended($checkoutProducts);
        product.quantity = parseInt($checkoutProducts.data('quantity'));
        products.push(product);
    }

    return products;
}

/**
 * @description simulate a page impression for checkout updates
 * @param order {OrderModel} the relative order model
 */
function setCheckoutProducts(order) {
    productOrder = [];
    var products = order.items.items;
    var analyticsProduct,
        variants;
    products.forEach(function(product) {
        if (product.variationAttributes.length > 1) {
            variants = product.variationAttributes[0].displayValue + ' | ' + product.variationAttributes[1].localizedSize || product.variationAttributes[1].displayValue;
        } else {
            variants = product.variationAttributes[0].displayValue;
        }
        analyticsProduct = {
            'name': product.productName,
            'id': product.id,
            'dimension1': product.masterProductID,
            'dimension2': product.articleNo,
            'dimension3': product.variationGroupID,
            'price': product.price.sales.decimalPrice,
            'brand': product.brand,
            'category': product.primaryCategoryID,
            'variant': variants,
            'quantity': product.quantity || 1,
            'discount': product.discount,
            'promotionName': product.promotionName,
            'listId': product.analyticsListId,
            'genderName': product.genderName,
            'itemSeason': product.itemSeason,
            'stockStatus': product.stockStatus
        };
        if (product.size) {
            analyticsProduct.size = product.size;
        }
        extendProductDataWithGA4Categories(analyticsProduct, product);
        productOrder.push(analyticsProduct);
    });
}

/**
 * @description extract the page type from the dom
 * @return pageType {String} the type of the page, mapped on analytics-pagemapping.js
 */
function getPageType() {
    var pageType = $('.page-meta-data').data('page-type');
    return pageType;
}

/**
 * @description determine if this is a search page and proceed to extract search's data, the track the event
 */
function searchHelper() {
    var $search = $('.js-analytics-search-keyword');

    var isCategorySearch = false,
        keyword = null,
        categoryId = null,
        numberOfResults = null;

    if ($search.length > 0) {
        numberOfResults = $search.data('analytics-results-number');
    } else {
        //it's a category search
        isCategorySearch = true;
        $search = $('.js-analytics-search-category');
        categoryId = $search.data('analytics-category-id');
    }

    keyword = $search.data('analytics-keyword');

    if (keyword && keyword.length > 0) {
        let searchData = {
            resultsNumber: numberOfResults && numberOfResults > 0 ? numberOfResults : 0,
            searchMethod: "standard",
            searchTerm: keyword
        };

        if (searchData.resultsNumber > 0) {
            events.ga4SuccessfulSearch(searchData);
        } else {
            events.ga4UnsuccessfulSearch(searchData);
        }
    }

    events.search(isCategorySearch, keyword, categoryId, numberOfResults);
}

/**
 * @description extract the data from the PDP dom and return a product formatted
 * @return product {Object} the product formatted
 */
function getPDPProduct() {
    var $product = $('.analytics-productPDP');
    var color = $product.data('color'),
        size = $product.data('size');
    var variant = size ? color + ' | ' + size : color;
    var isSalesStatus = getSalesStatus($product);

    var product = {
        'name': $product.data('name'),
        'id': $product.data('id'),
        'dimension1': $product.data('dimension1'),
        'dimension2': $product.data('dimension2'),
        'dimension3': $product.data('dimension3'),
        'price': $product.data('price'),
        'brand': $product.data('brand'),
        'category': $product.data('category'),
        'description': $product.data('description'),
        'productUrl': $product.data('canonicalUrl'),
        'categoryUrl': $product.data('categoryurl'),
        'imageUrl': $product.data('imageurl'),
        'variant': variant,
        'promotionName': $product.data('promotionName'),
        'discount': $product.data('discount'),
        'listId': $product.data('listId'),
        'genderName': $product.data('gender-name'),
        'itemSeason': $product.data('item-season'),
        'stockStatus': $product.data('stock-status'),
        'itemSalesStatus': isSalesStatus
    };
    if (size) {
        product.size = size;
    }
    extendProductDataWithGA4Categories(product, $product.data());
    return product;
}

/**
 * @description get all the products's impression from the DOM
 * @return products {List} a list of products impression
 */
function getProductDataPDP() {
    var products = [];
    var product = getPDPProduct();
    products.push(product);
    return products;
}

/**
 * @description get the product tile information
 * @param $product {div} the analytics-tileproduct div where the data will be extracted
 * @return product {Object} a the product Object contains the analytics informations
 */
function getProductClickTileData($product) {
    var color = $product.data('color'),
        size = $product.data('size');
    var variant = size ? color + ' | ' + size : color;
    var isSalesStatus = getSalesStatus($product);

    var product = {
        'name': $product.data('name'),
        'id': $product.data('id'),
        'dimension1': $product.data('dimension1'),
        'dimension2': $product.data('dimension2'),
        'dimension3': $product.data('dimension3'),
        'price': $product.data('price'),
        'brand': $product.data('brand'),
        'category': $product.data('category'),
        'position': $product.data('position'),
        'variant': variant,
        'discount': $product.data('discount'),
        'promotionName': $product.data('promotionName'),
        'list': window.bata_com_ns.analytics.pageType,
        'listId': $product.data('listId'),
        'genderName': $product.data('gender-name'),
        'itemSeason': $product.data('item-season'),
        'stockStatus': $product.data('stock-status'),
        'item_sales_status': isSalesStatus
    };
    if (size) {
        product.size = size;
    }
    extendProductDataWithGA4Categories(product, $product.data());
    return product;
}

/**
 * @description get all the promo informations, then launch the event
 */
function promoHelper(promotions) {
    if (promotions && promotions.length > 0) {
        var promo,
            analyticsPromotionsData = [];
        //get all promotions data and build the analytics promo object
        for (var i = 0; i < promotions.length; i++) {
            promo = promotions[i];
            analyticsPromotionsData.push({
                'id': promo.id,
                'name': promo.name,
                'creative': '',
                'position': promo.rank || 'center'
            });
        }
        var ga4Promotions = ga4GetPromotions(analyticsPromotionsData);
        events.ga4ViewPromotion(ga4Promotions);
        events.promoImpression(analyticsPromotionsData);
    }
}

/**
 * @description get all the promo information from the DOM, then process to pass the formatted data
 */
function promoImpressionHelper() {
    var $promo = $('span.analytics-promotion');
    var promotions = [],
        promo = {
            'id': $promo.data('id'),
            'name': $promo.data('name'),
            'rank': $promo.data('rank')
        };
    promotions.push(promo);
    promoHelper(promotions);
}

/**
 * @description get all the pagedesigner promo information from the DOM, then process to pass the formatted data
 */
function PageDesignerPromoImpressionHelper() {
    var analyticsPromotionsData = [];
    var $productsElements = $('.js-analytics-banner');
    if ($productsElements.length > 1) {
        $productsElements.each(function() {
            var $banner = $(this);
            if ($banner.data("analytics-title") && $banner.data("analytics-title") !== "" && $banner.data("analytics-title") !== "No title") {
                analyticsPromotionsData.push({
                    'id': $banner.data("analytics-title"),
                    'name': $banner.data("analytics-title")
                });
            }
        });
        if (analyticsPromotionsData.length) {
            var ga4Promotions = ga4GetPromotions(analyticsPromotionsData);
            events.ga4ViewPromotion(ga4Promotions);
            events.PageDesignerPromoImpression(analyticsPromotionsData);
        }
    }
}

/**
 * @description Extract the data from the variation product, then call the event
 * @param product {Object} The new variation product selected
 */
function variationClickHelper(product, variationType) {
    // The master category is always contained in the last breadcrumb, so the variation group ID
    var masterCategory = product.breadcrumbs && product.breadcrumbs.length > 0 ? product.breadcrumbs[product.breadcrumbs.length - 1] : null;

    // Extract product details
    var productName = product.productName,
        productID = product.id,
        masterProductID = product.masterProductID,
        articleNo = product.custom.articleNo,
        variationGroupID = masterCategory ? masterCategory.variationGroupID : '',
        price = product.price.sales.decimalPrice,
        brand = product.brand,
        categoryID = masterCategory ? masterCategory.id : '',
        description = product.longDescription,
        productUrl = product.canonicalUrl,
        categoryUrl = masterCategory ? new URL(masterCategory.url, document.baseURI).href : '',
        imageUrl = product.images.large[0].url,
        promotionName = product.promotionName,
        discount = product.discount,
        isSalesStatus = getSalesStatus(product),
        stockStatus = product.stockStatus,
        genderName = product.genderName,
        itemSeason = product.itemSeason,
        color,
        size,
        variation;
    // Detect the color selected
    for (let i = 0; i < product.variationAttributes[0].values.length; i++) {
        variation = product.variationAttributes[0].values[i];
        if (variation.selected) {
            color = variation.displayValue;
        }
    }
    // Detect the size selected, only if the size variation exist
    for (let i = 0; i < product.variationAttributes[1].values.length; i++) {
        variation = product.variationAttributes[1].values[i];
        if (variation.selected) {
            size = variation.localizedSize || variation.displayValue;
        }
    }
    var variant = size ? color + ' | ' + size : color;
    var $analyticsProduct = $('.analytics-productPDP');

    // Prepare the products object for analytics
    var products = [{
        'name': productName,
        'id': productID,
        'dimension1': masterProductID,
        'dimension2': articleNo,
        'dimension3': variationGroupID,
        'price': price,
        'brand': brand,
        'category': categoryID,
        'description': description,
        'productUrl': productUrl,
        'categoryUrl': categoryUrl,
        'imageUrl': imageUrl,
        'variant': variant,
        'promotionName': promotionName,
        'discount': discount,
        'listId': $analyticsProduct.data('listId'),
        'genderName': genderName,
        'itemSeason': itemSeason,
        'stockStatus': stockStatus,
        'item_sales_status': isSalesStatus
    }];
    if (size) {
        products.size = size;
    }
    extendProductDataWithGA4Categories(products[0], product);

    // Launch the event variantSelected
    events.variantSelected(window.bata_com_ns.analytics.currency, products);
    // Update the analytics producs data in the DOM, so it's ready for addToCart event
    $analyticsProduct.data('name', productName);
    $analyticsProduct.data('id', productID);
    $analyticsProduct.data('dimension1', masterProductID);
    $analyticsProduct.data('dimension2', articleNo);
    $analyticsProduct.data('dimension3', variationGroupID);
    $analyticsProduct.data('price', price);
    $analyticsProduct.data('brand', brand);
    $analyticsProduct.data('category', categoryID);
    $analyticsProduct.data('description', description);
    $analyticsProduct.data('canonicalUrl', productUrl);
    $analyticsProduct.data('categoryurl', categoryUrl);
    $analyticsProduct.data('imageurl', imageUrl);
    $analyticsProduct.data('color', color);
    $analyticsProduct.data('size', size);
    $analyticsProduct.data('category1', product.category1);
    $analyticsProduct.data('category2', product.category2);
    $analyticsProduct.data('category3', product.category3);
    $analyticsProduct.data('category4', product.category4);
    $analyticsProduct.data('category5', product.category5);
    $analyticsProduct.data('discount', product.discount);
    $analyticsProduct.data('promotionName', product.promotionName);
    $analyticsProduct.data('gender-name', genderName);
    $analyticsProduct.data('item-season', itemSeason);
    $analyticsProduct.data('stock-status', stockStatus);
    $analyticsProduct.data('item_sales_status', isSalesStatus);

    // Also collect the new possible promotions displayed
    promoHelper(product.promotions);

    // Update PDP analytics data for "share" event
    if (window.bata_com_ns.analytics.pageType === "product") {
        $('ul.social-icons').data('analytics-pid', variationGroupID);
    }
}

/**
 * @description simulate a page impression for checkout updates
 */
function checkoutUpdate() {
    let $user = $('#analytics-user');
    let $checkout = $('#checkout-main');
    let step = $checkout.attr('data-checkout-stage');
    step = PageTypeMap.PAGE_MAPPING[step] || step;
    window.bata_com_ns.analytics.pageType = step;

    let customerEmailMarketing = $user.data('email-marketing').toString();
    let customerEmail = $user.data('email');
    let customerCrmId = $user.data('customer-crm-id');
    let customerGender = $user.data('user-gender');
    let customerId = $user.data('customerid');
    let customerType = ($user.data('order-count') > 0) ? 'existing' : 'new';

    // set page-meta tag so that it's in sync with window.bata_com_ns.analytics.pageType
    pageMetaDataUtils.getOrSetPageMetaDataAttrElement('data-analytics-page-type', step);

    // set page-meta tag so that it's in sync with page's pageType
    pageMetaDataUtils.getOrSetPageMetaDataAttrElement('data-page-type', pageMetaDataUtils.PAGE_MAPPING[step] || step);

    events.pageImpression(customerType, step, window.location.href, customerEmail);
    let ga4CrmId = customerCrmId && customerCrmId !== 'guest' ? customerCrmId : null;
    let ga4Email = customerEmail && customerEmail !== 'guest' ? customerEmail : null;

    events.ga4PageView({
        pageType: step,
        pageURL: window.location.origin,
        pagePath: window.location.pathname,
        country: window.bata_com_ns.analytics.country,
        emailMarketing: customerEmailMarketing,
        email: ga4Email || undefined,
        internalClientId: customerId,
        loginStatus: ga4CrmId ? "true" : "false",
        gender: customerGender,
        userID: ga4CrmId || undefined,
        userType : ga4CrmId ? customerType : "guest"
    });
}

/**
 * @description simulate a page impression for checkout updates
 * @param $analyticsProduct {element} the div(s) that contains all the product's data
 * @returns products {List} a list that contains the product'data clicked
 */
function productClickHelper($analyticsProduct) {
    var products = [],
        product;
    //if the minicart is opened, there can be multiple tile of the same product, so pick the first one available
    $analyticsProduct = $analyticsProduct.length > 1 ? $analyticsProduct.first() : $analyticsProduct;

    product = getProductClickTileData($analyticsProduct);
    products.push(product);

    return products;
}

/**
 * @description launch both of the events for addToCart event
 * @param $product {element} the div that contains all the product's data
 * @param arTryonInfo {arTryonInfo} IN-AR TRY ON object with the tryon flags
 */
function addToCartHelper($product, arTryonInfo) {
    var product,
        products = [],
        pageType = window.bata_com_ns.analytics.pageType,
        pageView;

    if (pageType !== 'product' && $product) {
        product = getProductTileDataExtended($product);
        product.list = pageType;
        pageView = PageTypeMap.CART_MAPPING[pageType];
    } else {
        product = getPDPProduct();
    }
    product.quantity = 1;
    products.push(product);

    var currUser = getCustomerEmailAndPhone(),
        ga4Products = ga4GetProducts(products);

    events.ga4AddToCart(window.bata_com_ns.analytics.currency, ga4Products, parseFloat(product.price) * product.quantity);
    events.addToCart(window.bata_com_ns.analytics.currency, products, pageView, currUser.customerEmail, currUser.customerPhone, arTryonInfo);
    events.trackGAEvent(pageType, 'add to bag', product.id);
}

/**
 * @description launch both of the events for removeFromCart event
 * @param $product {element} the div that contains all the product's data
 * @param pageType {String} the page type where the product is removed
 * @param singleItem {String} only single item was removed from a cart
 */
function removeFromCartHelper($product, pageType, singleItem) {
    var product,
        products = [];

    product = getProductTileData($product);
    product.position = $product.data('position');
    product.quantity = singleItem ? 1 : parseInt($product.data('quantity'));
    product.list = pageType;
    product.dimension1 = $product.data('dimension1');
    product.dimension2 = $product.data('dimension2');
    product.dimension3 = $product.data('dimension3');
    products.push(product);

    var ga4Products = ga4GetProducts(products);
    events.ga4RemoveFromCart(window.bata_com_ns.analytics.currency, ga4Products, ga4GetProductsValue(ga4Products));
    events.removeFromCart(products);
    events.trackGAEvent(pageType, 'remove', product.id);
}

/**
 * @description launch the event addToWishlist
 * @param pid {String} the product's ID added
 */
function addToWishlistHelper(pid, $product) {
    var product = getProductClickTileData($product);
    var ga4Products = ga4GetProducts([product]);
    events.ga4AddToWishlist(window.bata_com_ns.analytics.currency, ga4Products, parseFloat(product.price || 0));
    events.trackGAEvent(PageTypeMap.WISHLIST_MAPPING[window.bata_com_ns.analytics.pageType], 'wishlist add', pid);
}

/**
 * @description launch the event removeFromWishlist
 * @param pid {String} the product's ID removed
 */
function removeFromWishlistHelper(pid, $product) {
    var product = getProductClickTileData($product);
    var ga4Products = ga4GetProducts([product]);
    events.ga4RemoveFromWishlist(window.bata_com_ns.analytics.currency, ga4Products, parseFloat(product.price || 0));
    events.trackGAEvent(PageTypeMap.WISHLIST_MAPPING[window.bata_com_ns.analytics.pageType], 'wishlist remove', pid);
}

/**
 * @description launch the checkout's events
 * @param step {int} the checkout's step
 * @param options {Object} various information, step based
 * @param isMiniCartOpened {boolean} optional: set on true only for checkout's second step, if the minicart has been opened
 */
function checkouStepHelper(step, options, isMiniCartOpened) {
    var products = getCheckoutProducts(step, isMiniCartOpened);
    var currUser = getCustomerEmailAndPhone();

    // GA4 begin_checkout (cart -> checkout)
    if (step === 1) {
        let ga4Products = ga4GetProducts(products);
        let ga4CartData = ga4GetCartData();
        events.ga4BeginCheckout(window.bata_com_ns.analytics.currency, ga4Products, ga4CartData.couponNames, ga4CartData.value);
    }
    //checkout inversion
    if (step === 2) {
        let ga4Products = ga4GetProducts(products);
        let ga4CartData = ga4GetCartData();
        let checkoutData = {
            currencyCode: window.bata_com_ns.analytics.currency,
            coupon: ga4CartData && ga4CartData.couponNames,
            value: ga4CartData && ga4CartData.value,
            stepLabel: "customer info",
            stepNumber: 2
        };
        events.ga4CheckoutProgress(checkoutData, ga4Products);
    }

    // GA4 checkout_progress (payment page load)
    if (step === 3) {
        let ga4Products = ga4GetProducts(products);
        let ga4CartData = ga4GetCartData();
        let checkoutData = {
            currencyCode: window.bata_com_ns.analytics.currency,
            coupon: ga4CartData && ga4CartData.couponNames,
            value: ga4CartData && ga4CartData.value,
            stepLabel: "payment info",
            stepNumber: 3
        };
        events.ga4CheckoutProgress(checkoutData, ga4Products);
    }

    events.pushCheckoutData(step, options, products, currUser.customerEmail, currUser.customerPhone);
}

/**
 * @description launch the checkout's events
 * @param step {int} the checkout's step
 * @param options {Object} various information, step based
 * @param order {Object} the order in execution
 */
function updateCheckoutData(step, options, order) {
    var option;
    // in case of multiple payment methods concatenate them (only for CO step 4)
    if (step === 4) {
        for (var i = 0; i < options.length; i++) {
            if (i === 0) {
                option = options[i].paymentMethod;
            } else {
                option += (' | ' + options[i].paymentMethod);
            }
        }
    } else {
        option = options;
    }

    setCheckoutProducts(order);
    var products = productOrder;

    // GA4 payment
    if (step === 4 && order) {
        let ga4Products = ga4GetProducts(products);
        let checkoutData = {
            currency: window.bata_com_ns.analytics.currency,
            paymentType: order.billing && order.billing.payment && order.billing.payment.selectedPaymentInstruments && order.billing.payment.selectedPaymentInstruments.length && order.billing.payment.selectedPaymentInstruments[0].labelMethod,
            coupon: order.couponsName,
            paymentMethodSaved: order.paymentMethodSaved,
            value: order.totals && order.totals.grandTotalDecimal
        };
        events.ga4AddPaymentInfo(checkoutData, ga4Products);
        events.ga4SelectProceedPurchase(order);
    }
    events.pushCheckoutData(step, option, products);
}

/**
 * @description launch the express checkout event
 * @param order {Object} the order in execution
 */
function expressCheckout(order) {
    var products = getProductsCartData(getPageType(), true);

    let ga4Products = ga4GetProducts(products);

    let paymentType = order.billing && order.billing.payment && order.billing.payment.selectedPaymentInstruments && order.billing.payment.selectedPaymentInstruments.length && order.billing.payment.selectedPaymentInstruments[0].labelMethod;

    let cartData = {
        coupon: order.couponsName,
        currency: window.bata_com_ns.analytics.currency,
        paymentMethodSaved: false,
        value: order.totals && order.totals.grandTotalDecimal,
        paymentType: paymentType
    };

    events.ga4AddPaymentInfo(cartData, ga4Products);

    var data = {
        defaultPaymentMethod: paymentType,
        shipping: order.shipping
    };

    events.ga4SelectProceedPurchase(data);
}

/**
 * @description launch the click express checkout button event
 * @param data {Object} contains the selected express checkout payment method
 */
function selectExpressCheckout(data) {
    events.ga4SelectExpressCheckout(data);
}

/**
 * @description launch the event order confirmation
 */
function orderConfirmHelper() {
    var step = 5;
    var products = getCheckoutProducts(step, false);
    events.pushCheckoutData(step, 'orderconfirmation', products);
    var $checkoutInfo = $('#analytics-checkoutInfo');
    var coupon = {
        'couponCodeName': $checkoutInfo.data('coupons-name'),
        'couponDiscount': $checkoutInfo.data('coupons-discount')
    };
    var currUser = getCustomerEmailAndPhone();
    var couponNames = coupon.couponCodeName;

    var ga4Products = ga4GetProducts(products);
    var ga4PurchaseData = {
        currency: window.bata_com_ns.analytics.currency,
        affiliation: 'Bata',
        transactionId: $checkoutInfo.data('id'),
        value: parseFloat($checkoutInfo.data('revenue')),
        shipping: parseFloat($checkoutInfo.data('shipping')),
        shippingTier: $checkoutInfo.data('shipping-tier'),
        paymentType: $checkoutInfo.data('payment-type'),
        tax: $checkoutInfo.data('tax'),
        adjustedMerchandizeTotalNetPrice: $checkoutInfo.data('adjustedMerchandizeTotalNetPrice'),
        adjustedMerchandizeTotalTax: $checkoutInfo.data('adjustedMerchandizeTotalTax'),
        bataStore: $checkoutInfo.data('bataStore'),
        cartId: $checkoutInfo.data('cartId'),
        transactionType: $checkoutInfo.data('transactionType'),
        email: $checkoutInfo.data('email')
    };
    if (couponNames) {
        ga4PurchaseData.coupon = couponNames;
    }
    events.ga4Purchase(ga4PurchaseData, ga4Products);
    events.purchase({
        id: $checkoutInfo.data('id'),
        revenue: $checkoutInfo.data('revenue'),
        tax: $checkoutInfo.data('tax'),
        shipping: $checkoutInfo.data('shipping'),
        coupon: coupon,
        products: products,
        customerEmail: currUser.customerEmail,
        customerPhone: currUser.customerPhone,
        adjustedMerchandizeTotalNetPrice: $checkoutInfo.data('adjustedMerchandizeTotalNetPrice'),
        adjustedMerchandizeTotalTax: $checkoutInfo.data('adjustedMerchandizeTotalTax')
    });
}

/**
 * @description update the analytics product quantity in Cart page
 * @param productID {String} the product's ID
 * @param quantity {Int} the quantity of the product
 */
function updateProductQuantity(productID, quantity) {
    var analyticsSelector = '.js-analytics-MainCart .analytics-product.' + productID;
    $(analyticsSelector).data('quantity', quantity);
}


/**
 * @description gets business hours (they are defined within Site preferences - businessHours field)
 */
function getBusinessHours() {
    var $bh = $('.analytics-businessHours');
    var content = $bh && $bh.length ? $bh.data('content') : null;
    return content;
}


/**
 * @description extract the data from the cart unavailability modal and fire removeFromCart event
 */
function removeFromCartByUnavailabilityModal() {
    var products = [],
        $product,
        $removedProducts = $('#unavailableProductsModal .cc-cart-item');

    var elementsFound = $removedProducts.length;
    if (elementsFound > 0) {
        $removedProducts.each(function() {
            $product = $(this);
            var product = {};
            product.id = $product.data('id');
            product.quantity = parseInt($product.data('quantity'));
            product.price = $product.data('priceTotal');
            products.push(product);
        });
    }

    var ga4Products = ga4GetProducts(products);
    events.ga4RemoveFromCart(window.bata_com_ns.analytics.currency, ga4Products, ga4GetProductsValue(ga4Products));
    events.removeFromCart(products);
}

/**
 * Track recommendations products view
 * @param {Object} recommendationContainer recommendation element
 */
function trackRecommendationsLists(recommendationContainer) {
    var product,
        $product,
        $recommendation;
    // loop recommendations carousels
    var $recommendations = $(recommendationContainer) || $('.recommendations');
    if ($recommendations.length > 0) {
        $recommendations.each(function() {
            $recommendation = $(this);
            var position = 0;
            var products = [];
            var recommendationName = $recommendation.find('.carousel-title').first().html().trim() || 'recommendation';
            var $products = $recommendation.find('.analytics-product.unregistered');
            if ($products.length > 0) {
                // loop products in a recommendation carousel
                $products.each(function() {
                    $product = $(this);
                    product = getProductTileData($product);
                    // skip invalid product
                    if (!product.id) {
                        return;
                    }
                    product.position = position;
                    $product.data('position', position);
                    product.listId = recommendationName;
                    $product.data('listId', recommendationName);
                    position++;
                    products.push(product);
                    $product.removeClass('unregistered');
                });
            }
            if (products.length === 0) {
                return;
            }
            // enhance product object with GA4 attributes
            var ga4Products = ga4GetProducts(products);
            // track products view event
            events.ga4ViewItemList(window.bata_com_ns.analytics.currency, ga4Products);
        });
    }
    return;
}

/**
 * Track scroll position
 */
function trackScrollPosition() {
    let scrollPercent = (($(window).scrollTop() / ($(document).height() - $(window).height())) * 100).toFixed();
    [25, 50, 75, 100].some(function(position) {
        if (scrollPercent < position) {
            return true;
        }
        if (scrollPercent >= position && !scrollPosition[position.toString()]) {
            scrollPosition[position.toString()] = true;
            events.ga4Scroll(position);
            return true;
        }
    });
}

/**
 * Parse abTests data off the page's DOM
 * Only active and visible ab tests are there (div's data)
 */
function getABtestsDataFromDOM(abTestId) {
    var list = [];
    $('.abTestsSegmentData').each(function() {
        var id = $(this).data('id');
        var segment = $(this).data('segment');

        if (typeof id !== 'undefined' && id !== null && id.length > 0 &&
            typeof segment !== 'undefined' && segment !== null && segment.length > 0 &&
            (!(typeof abTestId !== 'undefined' && abTestId !== null && abTestId.length > 0) || abTestId === id)) {
            var params = {
                variant_id: id,
                variant_name: segment,
                version_type: $(this).data('is-control-segment') ? 'control' : 'variant'
            };
            list.push(params);
        }
    });
    return list;
}

/**
 * Call ab test interection event that pushes active ab test data to the dataLayer
 * @param {Object} params - example: {abTestId: null, pageType: 'other'}
 */
function callAbTestInteraction(params) {
    var abTestId = null;
    var pageType = 'other';

    if (params) {
        abTestId = params.abTestId && params.abTestId.length > 0 ? params.abTestId : abTestId;
        if (params.pageType && params.pageType.length > 0) {
            pageType = params.pageType;
        }
        else if (window.bata_com_ns && window.bata_com_ns.pageType && window.bata_com_ns.pageType.length > 0) {
            pageType = window.bata_com_ns.pageType;
        }
    }

    events.abTestInteraction(getABtestsDataFromDOM(abTestId), pageType);
}


module.exports = {
    extendProductDataWithGA4Categories: extendProductDataWithGA4Categories,
    ga4GetProductItemListId: ga4GetProductItemListId,
    ga4GetProducts: ga4GetProducts,
    ga4GetPromotions: ga4GetPromotions,
    productClickHelper: productClickHelper,
    getProductTileDataExtended: getProductTileDataExtended,
    variationClickHelper: variationClickHelper,
    checkoutUpdate: checkoutUpdate,
    expressCheckout: expressCheckout,
    addToCartHelper: addToCartHelper,
    getProductsCartData: getProductsCartData,
    removeFromCartHelper: removeFromCartHelper,
    addToWishlistHelper: addToWishlistHelper,
    removeFromWishlistHelper: removeFromWishlistHelper,
    getPageType: getPageType,
    searchHelper: searchHelper,
    getProductDataPDP: getProductDataPDP,
    getProductsData: getProductsData,
    getProductsDataSearch: getProductsDataSearch,
    checkouStepHelper: checkouStepHelper,
    getCheckoutProducts: getCheckoutProducts,
    orderConfirmHelper: orderConfirmHelper,
    updateCheckoutData: updateCheckoutData,
    setCheckoutProducts: setCheckoutProducts,
    promoHelper: promoHelper,
    promoImpressionHelper: promoImpressionHelper,
    getProductClickTileData: getProductClickTileData,
    updateProductQuantity: updateProductQuantity,
    removeFromCartByUnavailabilityModal: removeFromCartByUnavailabilityModal,
    PageDesignerPromoImpressionHelper: PageDesignerPromoImpressionHelper,
    getBusinessHours: getBusinessHours,
    ga4GetCartData: ga4GetCartData,
    trackRecommendationsLists: trackRecommendationsLists,
    trackScrollPosition: trackScrollPosition,
    getABtestsDataFromDOM: getABtestsDataFromDOM,
    callAbTestInteraction: callAbTestInteraction,
    selectExpressCheckout: selectExpressCheckout
};



// WEBPACK FOOTER //
// ./cartridges/app_checkout_redesign/cartridge/client/default/js/analytics/analytics-utils.js